import React from 'react';
import PageWithoutSidebars from '../Page/PageWithoutSidebars.jsx';


export default class QUIZFB extends React.PureComponent {
  constructor() {
    super();
  }


  componentDidMount() {
(function(b,o,n,u,s){var a,t;a=b.createElement(u);a.async=1;a.src=s;t=b.getElementsByTagName(u)[0];t.parentNode.insertBefore(a,t);o[n]=o[n]||[]}) (document,window,'_qual_async','script','//nentgroup.qualifioapp.com/kit/qualp.2.min.js');
_qual_async.push(['createIframe', 'qualifio_insert_place_615490', 'nentgroup.qualifioapp.com', '20', '158CBB3A-B3D2-8C43-CEE9-D45F9E9F78B4', '100%', '867', '', '', '', 'max-width:810px;margin:0 auto;']);
    
  }
  componentWillUnmount() {
    
  }

  render() {
    return (
      <PageWithoutSidebars>
        <div className="tv-guide">
          <div id="qualifio_insert_place_615490" class="qualifio_iframe_wrapper"></div>
        </div>
      </PageWithoutSidebars>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/QUIZFB/QUIZFB.jsx